import React, { Component } from "react";

export default class ChevronArrows extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
            direction: props.direction
        }
    }

    shouldComponentUpdate(nextProps){
        return nextProps.direction !== this.state.direction;
    }
    
    componentDidUpdate(props){
        // Desired operations: ex setting state
        this.setState({
            direction: props.direction
        })
    }
    
    render() {
        if (this.state.direction === 'down') {
            return (
                <div style={{ display: "flex", flexDirection: "column", paddingLeft: "10px" }}>
                    <i className="fa fa-chevron-down" aria-hidden="true" style={{ fontSize: '14px' }}></i>
                    <i className="fa fa-chevron-down chevArrows" aria-hidden="true"></i>
                    {/* <i className="fa fa-chevron-down chevArrows" aria-hidden="true"></i> */}
                </div>
            )
        } else {
            return (
                <div style={{ display: "flex", flexDirection: "column", paddingLeft: "10px" }}>
                    <i className="fa fa-chevron-up" aria-hidden="true" style={{ fontSize: '14px' }}></i>
                    <i className="fa fa-chevron-up chevArrows" aria-hidden="true"></i>
                    {/* <i className="fa fa-chevron-up chevArrows" aria-hidden="true"></i> */}
                </div>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/ui_commons/chevronArrows.js